"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
require("./IconGauge.css");
/**
 * @see IconGaugeProps
 */
var IconGauge = /** @class */ (function (_super) {
    __extends(IconGauge, _super);
    function IconGauge(props) {
        return _super.call(this, props) || this;
    }
    IconGauge.prototype.render = function () {
        var _a = this.props, icon = _a.icon, color = _a.color, size = _a.size, gauge = _a.gauge, maxGauge = _a.maxGauge, title = _a.title, tag = _a.tag;
        var cssClasses = ['p-icongauge'];
        var roundedGauge = roundGauge(gauge, 0.5);
        var iconGauge = [];
        var ltr = document.getElementsByTagName('body')[0].dir !== 'rtl';
        var max = maxGauge || 5;
        var iconName = icon && icon.toLowerCase();
        constructClass(size || 'Large', 'p-f-sz');
        constructClass(color || 'Warning', 'p-t');
        for (var i = 0; i < max; i++) {
            if (i < roundedGauge - 0.5) {
                iconGauge.push(React.createElement("i", { className: "p-icon-" + iconName, key: i }));
            }
            else if (i < roundedGauge) {
                iconGauge.push(React.createElement("i", { className: "p-icon-" + iconName + "-half" + (ltr ? '' : ' flip'), key: i }));
            }
            else {
                iconGauge.push(React.createElement("i", { className: "p-icon-" + iconName + "-empty", key: i }));
            }
        }
        var props = {
            className: cssClasses.join(' '),
            'data-tag': tag,
            title: title
        };
        return (React.createElement("div", __assign({}, props),
            React.createElement("div", { "aria-hidden": "true" }, ltr ? iconGauge : iconGauge.reverse())));
        function customizeEnums(en) {
            var cases = {
                Xsmall: 'xs',
                Small: 'sm',
                Medium: 'md',
                Large: 'lg',
                Xlarge: 'xl',
                Xlarge2: '2x',
                Xlarge3: '3x',
                Xlarge4: '4x',
                Primary: 'Primary50',
                Secondary: 'Secondary50',
                Success: 'Success50',
                Warning: 'Warning50',
                Error: 'Error50',
                Info: 'Info50'
            };
            return cases[en] ? cases[en].toLowerCase() : en.toLowerCase();
        }
        function constructClass(prop, prefix) {
            var customProp = customizeEnums(prop);
            cssClasses.push(prefix + "-" + customProp);
        }
        function roundGauge(numberProp, interval) {
            var inv = 1 / interval;
            return Math.round(numberProp * inv) / inv;
        }
    };
    IconGauge.defaultProps = {
        icon: 'Star',
        color: 'Warning',
        size: 'Large',
        gauge: 2.5,
        maxGauge: 5,
        title: '',
        tag: null
    };
    return IconGauge;
}(React.Component));
exports.IconGauge = IconGauge;
exports.default = IconGauge;
//# sourceMappingURL=IconGauge.js.map


//////////////////
// WEBPACK FOOTER
// ../@csod/icon-gauge/build/control/IconGauge.js
// module id = 903
// module chunks = 0